import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled, { css } from 'styled-components';
import { useEffect } from 'react';
import { CloseIcon } from '@yoweb/ui/components/Icon/CloseIcon';
import { getColor, getSpace, getDuration, getZIndex } from '@yoweb/ui/styles/utils/theme';
import { useTranslation } from '@yoweb/next-i18next';
import { media } from '@yoweb/ui/styles/utils';
import { MenuIcon } from '@yoweb/ui/components/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IDS = {
  openButton: 'mobile-nav-open-button'
};

var MenuButton = function MenuButton(_ref) {
  var isOpen = _ref.isOpen,
      onClick = _ref.onClick;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  useEffect(function () {
    document.documentElement.style.setProperty('overflow', isOpen ? 'hidden' : null);
  }, [isOpen]);
  return /*#__PURE__*/_jsxs(ButtonWrapper, {
    "aria-label": t("header.".concat(isOpen ? 'open-menu' : 'close-menu')),
    onClick: onClick,
    "data-testid": IDS.openButton,
    children: [/*#__PURE__*/_jsx(CloseWrapper, {
      isOpen: isOpen,
      "aria-hidden": !isOpen,
      children: /*#__PURE__*/_jsx(CloseIcon, {})
    }), !isOpen && /*#__PURE__*/_jsx(MenuIcon, {
      size: 24
    })]
  });
};

var ButtonWrapper = styled.button.withConfig({
  componentId: "sc-bfqs6a-0"
})(["appearance:none;background-color:transparent;border:none;display:block;height:", ";padding:0;position:relative;width:", ";z-index:", ";", ""], getSpace('normal3'), getSpace('normal3'), getZIndex('layer'), media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var CloseWrapper = styled.div.withConfig({
  componentId: "sc-bfqs6a-1"
})(["left:50%;opacity:0;position:absolute;transform-origin:center;transform:translate3d(-50%,-50%,0) scale(0);transition:transform,opacity;transition-duration:", "ms;top:calc(50% + 1px);", ""], getDuration('interaction'), function (_ref2) {
  var isOpen = _ref2.isOpen;
  return isOpen && css(["color:", ";opacity:1;transform:translate3d(-50%,-50%,0) scale(1);"], getColor('base000'));
});
export default MenuButton;